import React, {useState} from 'react';
import {Link, Route, Switch} from "react-router-dom";
import useDidMountEffect from "../../utils/useDidMountEffect";
import apiUser from "../../apiUser";
import {useTecRmi} from "../../contexts/TecRmiContext";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import appUserRoutes from "../../appUserRoutes";
import ComponentMainGroup from "./Components/ComponentMainGroup";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import {TecRmiComponentTopicsProvider} from "../../contexts/TecRmiComponentTopicsContext";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {TAB_COMPONENTS} from "../../views/UserViews/TecRmi/MainView";
import ComponentSubGroup from "./Components/ComponentSubGroup";

const Components = () => {
  const { getApiPrimaryParams, showType, ident } = useTecRmi();
  const [componentTopics, setComponentTopics] = useState([])

  useDidMountEffect(() => {
    apiUser.tecRmi.common.componentTopicTree(getApiPrimaryParams())
      .then(res => setComponentTopics(res.data))
  })

  return <React.Fragment>
    <BreadcrumbsItem to={appUserRoutes.tecRmi.tab(ident, TAB_COMPONENTS)}>Podzespoły</BreadcrumbsItem>
    {
      componentTopics.length === 0
        ? <LoadingSpinner />
        : <TecRmiComponentTopicsProvider componentTopics={componentTopics}>
            <Switch>

              <Route path={appUserRoutes.tecRmi.tabComponentSubGroup()+'*'} component={ComponentSubGroup} />
              <Route path={appUserRoutes.tecRmi.tabComponentMainGroup()} component={ComponentMainGroup} />

              <Route component={() => {
                return <Row>
                  {componentTopics.map(componentTopic => <Col className="mb-4" sm={6} md={4} lg={3}>
                    <Card className="h-100">
                      <CardHeader><Link to={appUserRoutes.tecRmi.tabComponentMainGroup(ident, componentTopic.MaingroupId)}>{componentTopic.MaingroupText}</Link></CardHeader>
                      <CardBody>
                        {componentTopic.Subgroups.map((subgroup, key) => <Link
                          to={appUserRoutes.tecRmi.tabComponentSubGroup(ident, componentTopic.MaingroupId, subgroup.SubgroupId, subgroup.AvailableModules[0], '')}
                          key={key.toString()}
                        >{subgroup.SubgroupText}</Link>)}
                      </CardBody>
                    </Card>
                  </Col>)}
                </Row>
              }} />
            </Switch>
          </TecRmiComponentTopicsProvider>
    }

  </React.Fragment>
};

Components.propTypes = {

};

export default Components;